export default "__VITE_ASSET__12d5254d__"